export const userActionTypes={
    SET_CURRENT_USER:"SET_CURRENT_USER",
    SET_CURRENT_THEME_MODE:"SET_CURRENT_THEME_MODE",
    SET_DOCUMENT_DIRECTION:"SET_DOCUMENT_DIRECTION",
}

